import * as $$ from "jquery-selector-cache";

/**
 * Initialize the module
 */
export function initUserLogout() {
    // Exit when component don't exist
    if (!$$(".user-info").length) {
        return;
    }
    $(".logout").on("click", handleLogout);
}

/**
 * handle Logout.
 */
function handleLogout() {
    void $.ajax(
        " /api/user/logout")
        .done(() => {
            const location = window.location.href;
            window.location.href = location.replace("/b2b", "");
        });
}
